import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './SecondaryButton.module.scss';

const SecondaryButton = ({ onClick, title, size }) => (
  <button
    className={classnames('link-style--outline-dark',
      `btn--${size}`,
      styles['secondary-button'])}
    onClick={onClick}
    data-testid="secondary-button"
    type="button"
  >
    {title}
  </button>
);

SecondaryButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  size: PropTypes.string,
};

SecondaryButton.defaultProps = {
  size: 'medium',
};

export default SecondaryButton;
